var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.005 5.96201L1.636 9.33101L0.751999 8.44701L4.121 5.07801L0.585999 1.54301L1.459 0.669507L4.9945 4.20451L8.53 0.669006L9.414 1.55301L5.8785 5.08851L9.2375 8.44751L8.364 9.32101L5.005 5.96201Z",
    fill: "#6B7786"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightGrey);
export default __webpack_public_path__ + "static/media/close-light-grey.fae8dbee780d229330252c7b8f256e4b.svg";
export { ForwardRef as ReactComponent };